import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
    playbook: z.string().optional(),
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

// Playbooks moved out of settings to its own top-level page. Keep the legacy
// path so already-sent Slack notifications and bookmarks still land on it.
export const Route = createFileRoute('/_app/settings/agent-rules')({
    validateSearch: searchSchema,
    beforeLoad: ({ search }) => {
        throw redirect({ to: '/playbooks', search, replace: true });
    },
    component: () => null,
});
